const TRACKERS = {
  PROJECT_EXPORTED: "Project-Exported",
  EXPORT_INITIATED: "Export-Initiated",
  EXPORT_BTN_YOUTUBE_CLICKED: "Export-Btn-Youtube-Clicked",
  EXPORT_BTN_DOWNLOAD_CLICKED: "Export-Btn-Download-Clicked",
  EXPORT_BTN_TIKTOK_CLICKED: "Export-Btn-TikTok-Clicked",
  LTSF_PROJECT_FIRST_VIEWED: "ltsf_project_first_viewed",
  LFSF_VIDEO_LIKED: "ltsf_video_liked",
  LFSF_VIDEO_DISLIKED: "ltsf_video_disliked",
  LTSF_PROJECT_PUBLISHED: "ltsf_project_published",
  LTSF_PROJECT_DOWNLOADED: "ltsf_project_downloaded",
  LTSF_PROJECT_EDITED: "ltsf_project_edited",
  PLAN_UPGRADED: "plan_upgraded",
  LFTS_LITE_PLAN_UPGARDE: "Ltfs_lite_plan_upgarde",
  EXPORT_LITE_PLAN_UPGRADE_PUBLISH: "Export_lite_plan_upgrade_publish",
  LFTS_DUMMY_PROJECT_UPGRADE: "Ltfs_dummy_project_upgrade",
  LFTS_LOCKED_UPGRADE_CLICK: "Ltfs_locked_upgrade_click",
  LFTS_REGENRATION_UPGRADE_CLICK: "Ltfs_regenration_upgrade_click",
  LFTS_AI_REFRAME_APPLY_BTN_CLICKED: "Ltfs_ai_reframe_apply_btn_clicked",
  LFTS_REFRAME_LITE_UPGRADE: "Ltfs_reframe_lite_upgrade",
  LFTS_REFRAME_LITE_UPGRADE_PUBLISH_YOUTUBE: "Ltfs_reframe_lite_upgrade_publish_youtube",
  LFTS_REFRAME_LITE_UPGRADE_PUBLISH_DOWNLOAD: "Ltfs_reframe_lite_upgrade_publish_download",
  LFTS_REFRAME_LITE_UPGRADE_PUBLISH_TIKTOK: "Ltfs_reframe_lite_upgrade_publish_tiktok",
  LFTS_REFRAME_LITE_UPGRADE_PUBLISH_INSTAGRAM: "Ltfs_reframe_lite_upgrade_publish_instagram",
  LFTS_REFRAME_LITE_UPGRADE_LOCKED_SUCCESS: "Ltfs_reframe_lite_upgrade_locked_success",
  AI_AVATAR_HIGH_DEMAND_VIEWED: "ai_avatar_high_demand_viewed",
  AI_AVATAR_HIGH_DEMAND_DISMISSED: "ai_avatar_high_demand_dismissed",
};

export const TRACKER_PAGES = {
  SHORT_CLIPS: "Short Clips Page",
};

export default TRACKERS;